import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { Button, Card, Col, Form, message, PageHeader, Row, Select, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { ApiClient } from "../../../api-client/api.client";
import { FormInstance } from "antd/es/form";
import { AppointmentData } from "../../../interfaces/visit.interface";

interface IProps extends RouteComponentProps {}

interface IState {
  isLoading: boolean;
  appointment: AppointmentData | undefined;
}

export class AddDocumentComponent extends React.Component<IProps, IState> {
  private form = React.createRef<FormInstance>();

  public state: IState = {
    isLoading: false,
    appointment: undefined,
  };

  public componentDidMount(): void {
    this.getAppointment();
  }

  public getAppointment = async () => {
    try {
      this.setState({ isLoading: true });
      const { id } = this.props.match.params;
      const { data: appointment } = await ApiClient.getAppointment(id);

      this.setState({ appointment, isLoading: false });
    } catch {
      message.error("Document cannot be fetched!");
    }
  };

  private onFinish = async (values: any) => {
    this.setState({ isLoading: true });

    try {
      const { appointment } = this.state;

      await ApiClient.uploadFile({
        appointmentId: appointment?.id,
        patientId: appointment?.patientId,
        type: values.type,
        file: values.file.file.originFileObj,
      });

      message.success("Document successfully added!");
      this.props.history.push(`/appointments/${this.props.match.params?.id}/edit`);
    } catch (e) {
      console.log(e);
      message.error(e?.response?.data?.message || "Unknown Error");
      this.setState({ isLoading: false });
    }
  };

  public render() {
    const { isLoading } = this.state;
    return (
      <>
        <PageHeader
          onBack={() => this.props.history.push(`/appointments/${this.props.match.params?.id}/edit`)}
          ghost={false}
          style={{
            paddingLeft: 0,
            paddingRight: 0,
          }}
          title="Add document"
        />
        <Row gutter={24}>
          <Col xs={24} md={24} lg={12}>
            <Card title="Document" loading={isLoading}>
              <Form layout="vertical" ref={this.form} name="add-document" onFinish={this.onFinish}>
                <Form.Item name="type" label="Type" rules={[{ required: true }]}>
                  <Select placeholder="Select type">
                    <Select.Option value={"invoice"}>invoice</Select.Option>
                    <Select.Option value={"prescription"}>prescription</Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item name="file" label="File" rules={[{ required: true }]}>
                  <Upload
                    accept=".pdf"
                    customRequest={({ file, onSuccess }) => setTimeout(() => onSuccess(null, file), 0)}>
                    <Button>
                      <UploadOutlined /> Click to Upload
                    </Button>
                  </Upload>
                </Form.Item>
                <Form.Item style={{ marginBottom: 0 }}>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button loading={isLoading} type="primary" htmlType="submit">
                      Add
                    </Button>
                  </div>
                </Form.Item>
              </Form>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}
